import Image from 'app/Components/Shared/Image/image';
import React, {useEffect} from 'react';
import {Container, Row, Col, Button} from 'reactstrap';
import images from './images/images';
import Config from '../../../../Config';

const WarningMessagePopupContent = (props) => {
  const icon = props.icon ? Config.epiBaseUrl + props.icon : images.bigInfo;
  return (
    <Container className='warning-message-popup-content'>
      <Row>
        <Col>
          <Image src={icon} alt='icon' />
        </Col>
      </Row>
      <Row>
        <Col xs={12}>
          <span dangerouslySetInnerHTML={{__html: props.title}} />
        </Col>
      </Row>
      <Row>
        <Button color='link' className='newPurple w-100' onClick={() => props.closeModal()}>
          {props.btnText}
        </Button>
      </Row>
    </Container>
  );
};

export default WarningMessagePopupContent;
